import { getTheme, Text } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';
import { DataOperation_Stade } from '../../data/DataOperation_Stade';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxOperation_Stade extends Component {

    static defaultProps = {
        hiddenIds: [],
        idEcheancier: null,
        idOperation: null,
        inclureStadesTypesInutilises: false,
        inclureEcheancierAuxEchanciersLies: false,
        label: "Stade",
        onChange: (event, option, index, value, item) => null,
        placeholder: "Stade",
    };

    _theme = getTheme();

    _onChange = (event, option, index, value, item) => {

        const { allowFreeform, idEcheancier, idOperation, onChange } = this.props;

        const estSaisieManuelle = allowFreeform && !!value; // Si saisie manuelle effectuée dans la ComboBox
        const estSelectionNouvelleOption = allowFreeform && Object.keys(item).length === 0; // Si sélection d'une option préallablement saisie

        if (estSaisieManuelle || estSelectionNouvelleOption) {
            const newItem = {
                autresEcheanciersLies: [],
                estNouveauStade: true,
                idStade: option.key,
                nomStade: option.text,
                pourcentageCumulType: null,
                stadeType: false,
            };
            if (!!idOperation) newItem.idOperation = idOperation;
            if (!!idEcheancier) newItem.idEcheancier = idEcheancier;
            onChange(event, option, index, value, newItem);
        }
        else onChange(event, option, index, value, item);

    };

    _onRenderOption = (props, defaultRender) => {
        const option = defaultRender(props);
        if (!!props && !!props.data) {
            const { pourcentageCumul, stadeType } = props.data;
            const pourcentage = parseFloat((pourcentageCumul) * 100).toFixed(2);
            return <Fragment>
                <span style={{ fontSize: ".8rem" }} className="badge badge-secondary mr-1">{pourcentage}&nbsp;%</span>
                {option}
                {stadeType && <Text variant="tiny" styles={{ root: { color: this._theme.palette.themePrimary, paddingLeft: "3px", verticalAlign: "super" } }}>type</Text>}
            </Fragment>;
        }
        else return option;
    };

    render = () => {

        const { hiddenIds, idEcheancier, idOperation, inclureEcheancierAuxEchanciersLies, inclureStadesTypesInutilises } = this.props;

        let fetchMethod = null;
        if (!!idOperation)
            fetchMethod = () => DataOperation_Stade._chargementOperation_Stades({ idEcheancier, idOperation, inclureEcheancierAuxEchanciersLies, inclureStadesTypesInutilises }, null, false)

        const extractItems = (reponseAPIobjet) => {
            let items = EUIComboBox.defaultProps.extractItems(reponseAPIobjet);
            items = items.map(item => {
                const { pourcentageCumul, pourcentageCumulType } = item;
                let stade = {
                    ...item,
                    pourcentageCumul: pourcentageCumul || pourcentageCumulType || 0,
                    pourcentageAvancementTravaux: pourcentageCumul || pourcentageCumulType || 0
                };
                if (!!idOperation) stade.idOperation = idOperation;
                if (!!idEcheancier) stade.idEcheancier = idEcheancier;
                return stade;
            });
            return items;
        };

        const itemData = (item) => {
            const { pourcentageCumul, stadeType } = item;
            return { pourcentageCumul, stadeType };
        };

        return <EUIComboBox
            {...this.props}
            comboBoxOptionStyles={{ optionText: { verticalAlign: "bottom" } }}
            extractItems={extractItems}
            fetchMethod={fetchMethod}
            itemData={itemData}
            itemHidden={item => hiddenIds.includes(item.idStade)}
            itemKey={item => item.idStade}
            itemText={item => item.nomStade}
            onChange={this._onChange}
            onRenderOption={this._onRenderOption}
            stamp={[hiddenIds, idEcheancier, idOperation, inclureStadesTypesInutilises]}
        />;

    };

};